import React from 'react';
import { List, ListItem, Modal } from '@icarros/ids-react';
import { PROPOSAL_TIPS } from '../../constants';

import { ListWrapper } from './style';

interface ProposalTipsModalProps {
  modalOpen: boolean;
  setModalOpen(value: boolean): void;
}

export function ProposalTips({ modalOpen, setModalOpen }: ProposalTipsModalProps): JSX.Element {
  return (
    <Modal
      stateOpen={[modalOpen, setModalOpen]}
      body={
        <ListWrapper>
          <List>
            {PROPOSAL_TIPS.map(({ title, description }) => (
              <ListItem key={title} label={title} subLabel={description} />
            ))}
          </List>
        </ListWrapper>
      }
      title="confira meios de vender o seu veículo de forma segura"
      mainButtonText="entendi"
      mainButtonMethod={() => setModalOpen(false)}
    />
  );
}
